import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  totalRows: 0,
  version_info:"",
  api_version_info:""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_VERSION:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_VERSION:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      }
    
      case ActionTypes.TOTALROWS_VERSION:
        return {
          ...state,
          totalRows: action.totalRows
        }
      case ActionTypes.REQUEST_VERSION_OS:
        return {
          ...state,
          isFetching: true,
          didInvalidate: false
        }
      case ActionTypes.RECEIVE_VERSION_OS:
        return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        version_info:action.version_info,
        lastUpdated: action.receivedAt
        }
      case ActionTypes.REQUEST_VERSION_API:
        return {
          ...state,
          isFetching: true,
          didInvalidate: false
        }
      case ActionTypes.RECEIVE_VERSION_API:
        return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        api_version_info:action.api_version_info,
        lastUpdated: action.receivedAt
        }
    default:
      return state
  }
}